import React from "react";
import ScanRecordTableComponent from "./scanRecordTable.component";

export default function ScanRecordTableContainer({
  rows,
  isFetching,
  isError,
  page,
  tableFilter,
  rowsPerPage,
  totalFiltered,
  handleChangePage,
  handleChangeRowsPerPage,
  handleReload,
  paginationOptions,
  changeOrder,
  language,
  lang,
  handleMarkerClick
}) {
  return (
    <ScanRecordTableComponent
      rows={rows}
      isFetching={isFetching}
      isError={isError}
      handleReload={handleReload}
      language={language}
      page={page}
      rowsPerPage={rowsPerPage}
      totalFiltered={totalFiltered}
      paginationOptions={paginationOptions}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      tableFilter={tableFilter}
      changeOrder={changeOrder}
      lang={lang}
      handleMarkerClick={handleMarkerClick}
    />
  );
}
